// extracted by mini-css-extract-plugin
export var projects = "projects-module--projects--27o7e";